"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveRoutesWithGeoFilterOptions = void 0;
const legacy_models_1 = require("@daytrip/legacy-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const RetrieveRoutesOptions_1 = require("./RetrieveRoutesOptions");
let RetrieveRoutesWithGeoFilterOptions = class RetrieveRoutesWithGeoFilterOptions extends RetrieveRoutesOptions_1.RetrieveRoutesOptions {
    constructor() {
        super(...arguments);
        this.geoPolygonDirectionSensitive = false;
        this.isCrossBorder = false;
        this.isCountryDirectionSensitive = false;
    }
};
exports.RetrieveRoutesWithGeoFilterOptions = RetrieveRoutesWithGeoFilterOptions;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", legacy_models_1.GeoJsonGeofence)
], RetrieveRoutesWithGeoFilterOptions.prototype, "geoPolygonFrom", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", legacy_models_1.GeoJsonGeofence)
], RetrieveRoutesWithGeoFilterOptions.prototype, "geoPolygonTo", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], RetrieveRoutesWithGeoFilterOptions.prototype, "geoPolygonDirectionSensitive", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], RetrieveRoutesWithGeoFilterOptions.prototype, "originCountryIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], RetrieveRoutesWithGeoFilterOptions.prototype, "destinationCountryIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], RetrieveRoutesWithGeoFilterOptions.prototype, "isCrossBorder", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], RetrieveRoutesWithGeoFilterOptions.prototype, "isCountryDirectionSensitive", void 0);
exports.RetrieveRoutesWithGeoFilterOptions = RetrieveRoutesWithGeoFilterOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveRoutesWithGeoFilterOptions);
//# sourceMappingURL=RetrieveRoutesWithGeoFilterOptions.js.map